import { type DatabaseChangeType } from '@databases/types/redux';

import { getValueId } from '../../../../utils';
import { type YJSChangeHandler } from '../../types';

export const setValueCommentThreadResolved: YJSChangeHandler<
  DatabaseChangeType.SET_VALUE_COMMENT_THREAD_RESOLVED
> = ({ ydb, change }) => {
  ydb.mutate((db) => {
    db.setCommentThreadResolved(
      getValueId(change.entryId, change.fieldId),
      change.threadId,
      change.isResolved
    );
  });
};
